import { useState } from "react";
import { useLocation } from "react-router";
import useGetAccessToken from "@features/mySph/hooks/useGetAccessToken";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { ARTICLE_ERROR_GENERIC } from "@routes/Article/components/ArticleSubshare/constants";
import { LambdaResponsePayload } from "@routes/Article/types/Alacrity";
import { ENVIRONMENT } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";

import useAlacrity from "./useAlacrity";

export type AlacrityResList = {
  /** The article pathname to use as a key */
  pathname?: string;
  /** The alacrity response */
  alacrityRes: LambdaResponsePayload;
};

export default function useGenerateGiftURL(
  isPremium: boolean,
  isPreview?: boolean
) {
  const { isSubscriber } = useUserInfo();
  const getAccessToken = useGetAccessToken();
  const [alacrityRes, setAlacrityRes] = useState<AlacrityResList[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { pathname } = useLocation();
  const { generateGiftURL } = useAlacrity();

  const handleGenerateGiftURLModal = () => {
    if (isPreview) return;
    if (!isPremium) return;
    if (!isSubscriber) return;

    const fetchCall = async () => {
      try {
        const accessToken = await getAccessToken();

        if (!accessToken) throw new Error("accessToken is not present");

        const response = await generateGiftURL(
          `${getEnvironmentDomain(ENVIRONMENT)}${pathname}`,
          accessToken
        );

        const responseData = {
          pathname,
          alacrityRes: response,
        };

        setAlacrityRes([...alacrityRes, responseData]);
      } catch {
        const responseData = {
          pathname,
          alacrityRes: ARTICLE_ERROR_GENERIC,
        };

        setAlacrityRes([...alacrityRes, responseData]);
        console.error("useGetAccessToken is not present"); // eslint-disable-line no-console
      } finally {
        setIsModalOpen(true);
      }
    };

    fetchCall();
  };

  return {
    alacrityRes,
    setAlacrityRes,
    isModalOpen,
    setIsModalOpen,
    handleGenerateGiftURLModal,
  };
}
